<button type="button" class="btn-close close-modal" aria-label="Close" (click)="closeModal()"></button>
<div class="d-flex justify-content-center">
    <div class="input-group input-bg botom-white py-3">
        <input class="form-control text-white border-0 input-bg" type="search" placeholder="Search here" [(ngModel)]="searchValue">
        <div class="my-auto px-2 search-white pointer">
            <i class="bi bi-search"></i>
        </div>
    </div>
</div>